import React from 'react';
import { ApolloProvider } from 'react-apollo';
import MapPage from '../Map/MapPage';
import MapProvider from '../../context/ListingMapContext';
import { client } from '../client';
import SearchProvider from '../../context/SearchContext';
import ErrorBoundary from '../ErrorBoundary';

function MapContainer({
  categories,
  restaurant_categories,
  all_else_categories,
}) {
  return (
    <ApolloProvider client={client}>
      <ErrorBoundary>
        <MapProvider categories={categories}>
          <SearchProvider
            restaurant_categories={restaurant_categories}
            all_else_categories={all_else_categories}
          >
            <MapPage />
          </SearchProvider>
        </MapProvider>
      </ErrorBoundary>
    </ApolloProvider>
  );
}

export default MapContainer;
